

import Layout from '../components/Layout.js'
import iconSet from "../fonts/selection.json";
import IcomoonReact from "icomoon-react";

export const Home = () => {
    return (
        <Layout>
            <section className='overview-sec'>
                <h3>FrontEnd Developer</h3>
                <h2>Mirza Irtiza</h2>
                <p>
                Proficient Front End Developer effective at developing strong websites that
                achieve customer objectives. Familiar with working alongside Project
                manager to determine needs, create plans and optimize design usability
                and performance. Well-versed in using React js Next js and typescript as
                well as other resources to accomplish design requirements.
                </p>

                <div className='basicInfo'>
                    <div className='col-12 col-xl-6 col-md-12 px-3 mb-2'>
                        <div className='basicList'>
                            <ul>
                                <li>
                                    <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>Birthday : </strong>
                                    18 july 1995
                                </li>
                                <li>
                                    <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>WEBSITE  : </strong>
                                    https://mirza-irtiza.netlify.app/
                                </li>
                                <li>
                                    <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>PHONE  : </strong>
                                    +92 302 9050 360
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6 col-md-12 px-3 mb-2'>
                        <div className='basicList'>
                            <ul>
                                <li>
                                    <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>DEGREE  : </strong>
                                    BSCS - Computer Science
                                </li>
                                <li>
                                    <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>Mail : </strong>
                                    mirzairtiza15@gmail.com
                                </li>
                                <li>
                                    <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>LINKEDIN :  </strong>
                                    mirza-irtiza-wahid
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className='serviceSec'>
                    <h3>WHAT I DO</h3>
                    <h2>SERVICES</h2>

                    <div className='row'>
                        <div className='col-12 col-xl-6 col-md-12 px-3 mb-2'>
                            <div className='serviceCard'>
                                <div className='imgWrap'>
                                <IcomoonReact iconSet={iconSet} color="#99be77" size={25} icon="laptop" />
                                </div>
                                <div className='serviceInfo'>
                                    <h3>Website Development</h3>
                                    <p>
                                        React.js is always my top priority,
                                        I provide FrontEnd services such as; E-commerce Solutions
                                        and Static and dynamic UI Website Developement with responsive.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-xl-6 col-md-12 px-3 mb-2'>
                            <div className='serviceCard'>
                                <div className='imgWrap'>
                                <IcomoonReact iconSet={iconSet} color="#99be77" size={25} icon="mobile"/>
                                </div>
                                <div className='serviceInfo'>
                                    <h3>Mobile Development</h3>
                                    <p>
                                    Transforming ideas into vibrant, cross-platform mobile applications with the power of React Native's versatility and efficiency.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </Layout>
    )
}

export default Home